export default class GetInspectionPassThroughChartRequest {
    public WeeksToGet: number = 6;
}